<template>
    <div id="log_page" class="container-fluid">
        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="actions" slot-scope="props" class="text-right">
                <router-link :to="{ path: `/logs/report-builder-history/client/${props.row.id}` }" class="btn btn-info reverse">Builder Changes</router-link>
                <router-link :to="{ path: `/logs/archive-history/client/${props.row.id}` }" class="btn btn-info reverse">Archive Changes</router-link>
            </div>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                columns: ['name', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        name:    'Client Name',
                        actions: ''
                    },
                    sortable: ['name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} clients|{count} clients|One client',
                        filter: '',
                        filterPlaceholder: 'Search clients...',
                        noResults: 'No matching clients'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/clients')
                ])
                .then(axios.spread(clients => {
                    this.tableData = clients.data;
                }));
            }
        }
    }
</script>
